import React, { useState } from 'react';
import wixLogo from '../assets/wix.png';
import agFacturaLogo from '../assets/ag.png';
import bidireccional from '../assets/bidireccional.png';
import { FaSignInAlt } from 'react-icons/fa';


export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const envUser = process.env.REACT_APP_USER;
    const envPass = process.env.REACT_APP_PASS;

    if (username === envUser && password === envPass) {
      localStorage.setItem('loggedIn', 'true');
      onLogin(true);
    } else {
      alert('Usuario o contraseña incorrectos');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 border rounded shadow">
      <h1 className="text-2xl font-bold mb-4">AG Factura Wix Stores Connector</h1>
      <div className="flex gap-4 justify-center mb-6">
        <img src={wixLogo} alt="Wix Logo" className="h-12 rounded" />
        <img src={bidireccional} alt="Bidireccional Logo" className="h-12" />
        <img src={agFacturaLogo} alt="AG Factura Logo" className="h-12" />
      </div>

      <h2 className="text-2xl font-bold mb-4 text-center">Iniciar Sesión</h2>

      <form onSubmit={handleSubmit}>
        <label className="block mb-3">
          Usuario:
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            className="border rounded w-full px-3 py-2 mt-1"
            required
            autoFocus
          />
        </label>

        <label className="block mb-5">
          Contraseña:
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="border rounded w-full px-3 py-2 mt-1"
            required
          />
        </label>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition flex items-center justify-center gap-2"
        >
          <FaSignInAlt className="text-white" />
          Entrar
        </button>
      </form>
    </div>
  );
}
